import { BinaryQuestionTemplate } from '@templates';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../routes/Routes';
import { useHighwaysStore } from '@highways/store/store';
import {
  parseZodErrors,
  stringFieldSchema,
} from '@highways/utils/zod-validations';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { BINARY_OPTIONS_ERROR } from '@highways/constants/errorMessages';
import { scrollTop } from '@utils';

export const HasDamageCausedInjuryPage = () => {
  const { highwaysType, hasDamageCausedInjury, updateHasDamageCausedInjury } =
    useHighwaysStore();
  const [result, setResult] = useState(hasDamageCausedInjury);
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  // redirect to the landing page if the highwaysType is not set
  useEffect(() => {
    if (!highwaysType) {
      navigate(RoutesList.TEST_LANDING_PAGE);
    }
  }, []);

  const pageTitle = `Is the ${highwaysType} damage hazardous or has it caused an injury?`;

  const handleChange = (option: string) => {
    setResult(option as 'Yes' | 'No');
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = stringFieldSchema(
          'hasDamageCausedInjury',
          BINARY_OPTIONS_ERROR.required.message,
        ).parse({
          hasDamageCausedInjury: result,
        });
        if (validatedData.hasDamageCausedInjury) {
          updateHasDamageCausedInjury(
            validatedData.hasDamageCausedInjury as 'Yes' | 'No',
          );
        }
        if (result === 'Yes') {
          navigate(RoutesList.CALL_US);
        } else if (result === 'No') {
          navigate(RoutesList.HIGHWAYS_DAMAGE_TYPE);
        }
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.HIGHWAYS_HOME + `?type=${highwaysType}`),
  };
  const options = [
    {
      labelText: 'Yes',
      isDefault: hasDamageCausedInjury === 'Yes',
    },
    {
      labelText: 'No',
      isDefault: hasDamageCausedInjury === 'No',
    },
  ];

  return (
    <BinaryQuestionTemplate
      title={pageTitle}
      options={options}
      errorPath={'hasDamageCausedInjury'}
      errorMessages={errorMessages}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
